module.exports = __webpack_public_path__ + "audit_trail.png?5e6ab2b0afc04c07d551c63c49b04dfc";